import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LAST_SELECTED_LANG_KEY, LocalizationType } from '../../localization';
import { StorageService } from '../storage';

@Injectable()
class LanguageInterceptor implements HttpInterceptor {
  private readonly storageService = inject(StorageService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = this.storageService.get<LocalizationType>(LAST_SELECTED_LANG_KEY);

    if (!lang) {
      return next.handle(request);
    }

    const modifiedRequest = request.clone({
      setHeaders: {
        Locale: String(lang),
      },
    });

    return next.handle(modifiedRequest);
  }
}

export const languageInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
];
